import {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {PayPer} from '@deliveriesondemand/dod-data';

import Select from '-/components/fields/Select';
import {NumberInput} from '-/components/fields/NumberInput';
import EmploymentInfoService from '-/services/EmploymentInfoService';
import {Control, ControlGroup} from '-/components/fields/Control';
import {Radio, RadioGroup} from '-/components/fields/RadioGroup';
import Legend from '-/components/fields/Legend';

class PayInfo extends Component {
    static propTypes = {
        pay: PropTypes.shape({
            payType: PropTypes.string,
            rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            per: PropTypes.string,
            hoursPerWeek: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        }),
        onChange: PropTypes.func
    };

    static defaultProps = {
        onChange: () => {}
    };

    constructor(props) {
        super(props);
        this.handlePayTypeChange = this.handlePayTypeChange.bind(this);
    }

    set(key, value) {
        const {pay = {}, onChange} = this.props;

        EmploymentInfoService.set('pay', {...pay, [key]: value});
        onChange();
    }

    handlePayTypeChange(value) {
        this.set('payType', value);
        if (value === 'salary') {
            setTimeout(() => this.set('per', 'year'), 0);
        }
    }

    getErrors() {
        const {pay = {}} = this.props;
        const {payType, rate, hoursPerWeek} = pay;
        const msgs = [];
        if (isNaN(rate) || rate <= 0) {
            msgs.push('Pay rate is empty');
        }
        if (payType === 'hourly' && (isNaN(hoursPerWeek) || hoursPerWeek <= 0)) {
            msgs.push('Hours per week is empty');
        }
        return msgs;
    }

    render() {
        const {pay} = this.props;
        const {payType, rate, per, hoursPerWeek} = pay;
        let total = null;
        if (payType === 'hourly' && !isNaN(rate) && !isNaN(hoursPerWeek)) {
            total = (rate * hoursPerWeek).toFixed(2);
        }
        const cls = classNames('pay-rate', {inline: payType === 'salary'});
        return (
            <ControlGroup labelWidth={200}>
                <Legend>How do you get paid?</Legend>
                <RadioGroup onChange={this.handlePayTypeChange} labelWidth={200} label="Pay Type">
                    <Radio name="payType" label="Salary" value="salary" id="payType-salary" checked={payType === 'salary'} />
                    <Radio name="payType" label="Hourly" value="hourly" id="payType-hourly" checked={payType === 'hourly'} />
                </RadioGroup>
                <Control>
                    <div className={cls} label="Pay Rate $">
                        <NumberInput
                            label="$"
                            placeholder="$XXX"
                            value={rate}
                            onChange={value => this.set('rate', value)} />
                        {payType === 'salary' ? (
                            <Select ref="per" onChange={value => this.set('per', value)}>
                                {Object.keys(PayPer).map(key => {
                                    const label = PayPer[key];

                                    return (
                                        <option key={key} value={key} selected={per === key}>{label}</option>
                                    );
                                })}
                            </Select>
                        ) : null}
                    </div>
                </Control>
                {payType === 'hourly' ? (
                    <Control>
                        <NumberInput
                            label="Hours per week"
                            value={hoursPerWeek}
                            placeholder="e.g. 40"
                            onChange={value => this.set('hoursPerWeek', value)} />
                    </Control>
                ) : null}
                {total ? (
                    <Control>
                        <NumberInput
                            label="Total weekly pay $"
                            value={total} />
                    </Control>
                ) : null}
            </ControlGroup>
        );
    }
}

export default PayInfo;
